var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBronzeBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_743_445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9762 0L15.3648 8.82348H7.89062L11.211 0H18.9762Z",
    fill: "#8E2323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.71 7.30176H7.61413C7.08498 7.30176 6.64844 7.7383 6.64844 8.26745V13.4266H16.6757V8.26745C16.6757 7.72507 16.2392 7.30176 15.71 7.30176ZM15.9614 9.19345H7.17758V8.79659C7.17758 8.37327 7.52153 8.0161 7.95807 8.0161H15.1941C15.6174 8.0161 15.9746 8.36005 15.9746 8.79659V9.19345H15.9614Z",
    fill: "#FF9B50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.39844 0L7.89079 8.82348H15.365L11.9652 0H4.39844Z",
    fill: "#FA352C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.54352 8.82348L5.7866 0H5.36328L9.10698 8.82348H9.54352Z",
    fill: "#7F0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.9185 8.82348L7.1616 0H6.73828L10.482 8.82348H10.9185Z",
    fill: "#7F0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.481 8.82348L8.73733 0H8.30078L12.0577 8.82348H12.481Z",
    fill: "#7F0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.9888 8.82348L10.2451 0H9.80859L13.5655 8.82348H13.9888Z",
    fill: "#7F0B0B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.1819 22.8675C23.144 16.9395 19.1183 11.354 13.1903 10.3919C7.26227 9.42983 1.67674 13.4555 0.714657 19.3835C-0.247423 25.3116 3.77827 30.8971 9.7063 31.8592C15.6343 32.8213 21.2199 28.7956 22.1819 22.8675Z",
    fill: "#FFB839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.9615 13.2686C20.8267 15.2264 21.9776 17.8721 21.9776 20.7824C21.9776 26.7882 17.1095 31.6563 11.1037 31.6563C8.1934 31.6563 5.53445 30.5054 3.58984 28.6402C5.57413 30.7039 8.35214 32.0003 11.4476 32.0003C17.4534 32.0003 22.3216 27.1321 22.3216 21.1263C22.3216 18.0441 21.0384 15.2528 18.9615 13.2686Z",
    fill: "#FF9B50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.1988 22.545C20.983 17.7132 17.7017 13.1605 12.8698 12.3763C8.03799 11.5921 3.48531 14.8734 2.70113 19.7053C1.91695 24.5371 5.19824 29.0898 10.0301 29.874C14.8619 30.6582 19.4146 27.3769 20.1988 22.545Z",
    fill: "#FF9B50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M10.5741 27.3965C10.918 27.6743 11.0106 28.1241 11.0106 28.1241C11.0106 28.1241 10.5476 28.1373 10.1904 27.8595C9.84651 27.5817 9.75391 27.1319 9.75391 27.1319C9.75391 27.1319 10.2301 27.1187 10.5741 27.3965Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.1497 28.0975C10.573 27.952 11.0096 28.1108 11.0096 28.1108C11.0096 28.1108 10.7715 28.5076 10.3481 28.6531C9.92483 28.7987 9.48828 28.6399 9.48828 28.6399C9.48828 28.6399 9.73962 28.2431 10.1497 28.0975Z",
    fill: "#FFB448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.2282 27.0257C9.53246 27.3432 9.55891 27.8062 9.55891 27.8062C9.55891 27.8062 9.09591 27.7532 8.79165 27.4358C8.48739 27.1183 8.46094 26.6553 8.46094 26.6553C8.46094 26.6553 8.92394 26.7082 9.2282 27.0257Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M8.71195 27.6737C9.14849 27.5811 9.55858 27.806 9.55858 27.806C9.55858 27.806 9.26755 28.1632 8.83101 28.2558C8.39446 28.3484 7.98438 28.1235 7.98438 28.1235C7.98438 28.1235 8.2754 27.7531 8.71195 27.6737Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M8.15498 26.4963C8.40632 26.8535 8.35341 27.3165 8.35341 27.3165C8.35341 27.3165 7.90364 27.1974 7.65229 26.827C7.40095 26.4698 7.45386 26.0068 7.45386 26.0068C7.45386 26.0068 7.90364 26.1391 8.15498 26.4963Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M7.54762 27.0522C7.9974 27.039 8.3678 27.3168 8.3678 27.3168C8.3678 27.3168 8.02385 27.6343 7.57408 27.6475C7.12431 27.6607 6.75391 27.3829 6.75391 27.3829C6.75391 27.3829 7.09785 27.0787 7.54762 27.0522Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M7.16131 25.7033C7.32005 26.1134 7.16131 26.55 7.16131 26.55C7.16131 26.55 6.75122 26.3251 6.60571 25.915C6.44697 25.5049 6.60571 25.0684 6.60571 25.0684C6.60571 25.0684 7.00257 25.2932 7.16131 25.7033Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M6.43647 26.0862C6.87302 26.1788 7.16405 26.5359 7.16405 26.5359C7.16405 26.5359 6.75396 26.7608 6.31742 26.6682C5.88087 26.5756 5.58984 26.2185 5.58984 26.2185C5.58984 26.2185 5.99993 26.0068 6.43647 26.0862Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M6.40848 24.7638C6.4614 25.2003 6.19682 25.584 6.19682 25.584C6.19682 25.584 5.85288 25.2665 5.79997 24.8299C5.74705 24.3934 6.01162 24.0098 6.01162 24.0098C6.01162 24.0098 6.35557 24.3405 6.40848 24.7638Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M5.60205 24.9886C5.99891 25.1738 6.19733 25.5971 6.19733 25.5971C6.19733 25.5971 5.74756 25.7162 5.33747 25.531C4.94062 25.3458 4.74219 24.9224 4.74219 24.9224C4.74219 24.9224 5.20519 24.8034 5.60205 24.9886Z",
    fill: "#FFB448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M5.77444 23.5989C5.73475 24.0355 5.40404 24.3662 5.40404 24.3662C5.40404 24.3662 5.13947 23.9826 5.16592 23.5593C5.20561 23.1227 5.53632 22.792 5.53632 22.792C5.53632 22.792 5.8009 23.1624 5.77444 23.5989Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M4.94127 23.6519C5.29844 23.9165 5.40427 24.3663 5.40427 24.3663C5.40427 24.3663 4.94127 24.3927 4.5841 24.1282C4.22692 23.8636 4.12109 23.4138 4.12109 23.4138C4.12109 23.4138 4.5841 23.3874 4.94127 23.6519Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M5.44133 22.4877C5.3355 22.911 4.95187 23.1888 4.95187 23.1888C4.95187 23.1888 4.74021 22.7787 4.84604 22.3554C4.95187 21.9321 5.3355 21.6543 5.3355 21.6543C5.3355 21.6543 5.54715 22.0644 5.44133 22.4877Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M4.60861 22.4089C4.91287 22.7264 4.95256 23.1894 4.95256 23.1894C4.95256 23.1894 4.48956 23.1365 4.17207 22.8322C3.85458 22.528 3.82812 22.0518 3.82812 22.0518C3.82812 22.0518 4.29113 22.0914 4.60861 22.4089Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M5.40416 21.2445C5.1925 21.6282 4.75596 21.8001 4.75596 21.8001C4.75596 21.8001 4.66336 21.3504 4.86178 20.9667C5.07344 20.5831 5.50999 20.4111 5.50999 20.4111C5.50999 20.4111 5.61582 20.8477 5.40416 21.2445Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M4.60861 20.9666C4.8335 21.3503 4.75413 21.8 4.75413 21.8C4.75413 21.8 4.31759 21.6413 4.0927 21.2709C3.86781 20.8873 3.94718 20.4375 3.94718 20.4375C3.94718 20.4375 4.39696 20.583 4.60861 20.9666Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M5.62903 19.9881C5.338 20.3188 4.875 20.3849 4.875 20.3849C4.875 20.3849 4.88823 19.9219 5.17926 19.5912C5.47029 19.2605 5.93329 19.1943 5.93329 19.1943C5.93329 19.1943 5.92006 19.6573 5.62903 19.9881Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M4.92441 19.5379C5.05669 19.9613 4.85826 20.3846 4.85826 20.3846C4.85826 20.3846 4.46141 20.1332 4.34235 19.7099C4.21006 19.2866 4.40849 18.8633 4.40849 18.8633C4.40849 18.8633 4.79212 19.1146 4.92441 19.5379Z",
    fill: "#FFB448"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M6.07559 18.9563C5.71842 19.2077 5.24219 19.168 5.24219 19.168C5.24219 19.168 5.36125 18.7182 5.71842 18.4669C6.07559 18.2155 6.55182 18.2552 6.55182 18.2552C6.55182 18.2552 6.43276 18.705 6.07559 18.9563Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M5.4955 18.361C5.52196 18.7976 5.24416 19.168 5.24416 19.168C5.24416 19.168 4.92667 18.8372 4.90021 18.4007C4.87376 17.9642 5.15156 17.5938 5.15156 17.5938C5.15156 17.5938 5.46904 17.9245 5.4955 18.361Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M6.64502 18.0175C6.24816 18.2159 5.78516 18.0969 5.78516 18.0969C5.78516 18.0969 5.97036 17.6736 6.36721 17.4751C6.76407 17.2767 7.22707 17.3958 7.22707 17.3958C7.22707 17.3958 7.04187 17.8323 6.64502 18.0175Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M6.17117 17.3426C6.13148 17.7792 5.78754 18.0967 5.78754 18.0967C5.78754 18.0967 5.52296 17.713 5.56265 17.2765C5.60234 16.8399 5.94628 16.5225 5.94628 16.5225C5.94628 16.5225 6.21085 16.9061 6.17117 17.3426Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M12.9834 27.33C12.6395 27.6078 12.5469 28.0576 12.5469 28.0576C12.5469 28.0576 13.0099 28.0708 13.367 27.793C13.711 27.5152 13.8036 27.0654 13.8036 27.0654C13.8036 27.0654 13.3274 27.0654 12.9834 27.33Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M13.4067 28.0448C12.9834 27.8993 12.5469 28.058 12.5469 28.058C12.5469 28.058 12.785 28.4549 13.2083 28.6004C13.6316 28.7459 14.0682 28.5872 14.0682 28.5872C14.0682 28.5872 13.8168 28.1903 13.4067 28.0448Z",
    fill: "#FFB448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M14.1588 27.0257C13.8546 27.3432 13.8281 27.8062 13.8281 27.8062C13.8281 27.8062 14.2911 27.7532 14.5954 27.4358C14.8996 27.1183 14.9261 26.6553 14.9261 26.6553C14.9261 26.6553 14.4631 26.7082 14.1588 27.0257Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M14.6748 27.6747C14.2382 27.5821 13.8281 27.807 13.8281 27.807C13.8281 27.807 14.1192 28.1642 14.5557 28.2568C14.9922 28.3494 15.4023 28.1245 15.4023 28.1245C15.4023 28.1245 15.1113 27.7541 14.6748 27.6747Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M15.2304 26.4572C14.9791 26.8144 15.032 27.2774 15.032 27.2774C15.032 27.2774 15.4818 27.1583 15.7331 26.7879C15.9844 26.4308 15.9315 25.9678 15.9315 25.9678C15.9315 25.9678 15.4818 26.1001 15.2304 26.4572Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M15.8397 27.0132C15.3899 26.9999 15.0195 27.2777 15.0195 27.2777C15.0195 27.2777 15.3635 27.5952 15.8132 27.6084C16.263 27.6217 16.6334 27.3439 16.6334 27.3439C16.6334 27.3439 16.2762 27.0264 15.8397 27.0132Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M16.1838 25.677C16.0251 26.0871 16.1838 26.5236 16.1838 26.5236C16.1838 26.5236 16.5939 26.2987 16.7394 25.8886C16.8982 25.4785 16.7394 25.042 16.7394 25.042C16.7394 25.042 16.3426 25.2669 16.1838 25.677Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M16.9112 26.0741C16.4746 26.1667 16.1836 26.5239 16.1836 26.5239C16.1836 26.5239 16.5937 26.7488 17.0302 26.6562C17.4668 26.5636 17.7578 26.2064 17.7578 26.2064C17.7578 26.2064 17.3477 25.9815 16.9112 26.0741Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M16.9757 24.6847C16.9228 25.1212 17.1874 25.5049 17.1874 25.5049C17.1874 25.5049 17.5313 25.1874 17.5843 24.7508C17.6372 24.3143 17.3726 23.9307 17.3726 23.9307C17.3726 23.9307 17.0287 24.2482 16.9757 24.6847Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M17.7828 24.8968C17.3859 25.082 17.1875 25.5053 17.1875 25.5053C17.1875 25.5053 17.6373 25.6244 18.0474 25.4392C18.4442 25.254 18.6426 24.8306 18.6426 24.8306C18.6426 24.8306 18.1796 24.7116 17.7828 24.8968Z",
    fill: "#FFB448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M17.5468 23.5735C17.5865 24.0101 17.9173 24.3408 17.9173 24.3408C17.9173 24.3408 18.1818 23.9572 18.1554 23.5339C18.1157 23.0973 17.785 22.7666 17.785 22.7666C17.785 22.7666 17.5072 23.137 17.5468 23.5735Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M18.381 23.6259C18.0238 23.8905 17.918 24.3403 17.918 24.3403C17.918 24.3403 18.381 24.3667 18.7381 24.1022C19.0953 23.8376 19.2011 23.3878 19.2011 23.3878C19.2011 23.3878 18.7381 23.3746 18.381 23.6259Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M17.8773 22.4623C17.9831 22.8856 18.3667 23.1634 18.3667 23.1634C18.3667 23.1634 18.5784 22.7533 18.4726 22.33C18.3667 21.9067 17.9831 21.6289 17.9831 21.6289C17.9831 21.6289 17.7715 22.039 17.8773 22.4623Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M18.7111 22.3826C18.4069 22.7 18.3672 23.1631 18.3672 23.1631C18.3672 23.1631 18.8302 23.1101 19.1477 22.8059C19.4519 22.4884 19.4916 22.0254 19.4916 22.0254C19.4916 22.0254 19.0154 22.0651 18.7111 22.3826Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M17.9174 21.2582C18.1291 21.6418 18.5656 21.8138 18.5656 21.8138C18.5656 21.8138 18.6582 21.364 18.4598 20.9804C18.2482 20.5968 17.8116 20.4248 17.8116 20.4248C17.8116 20.4248 17.7058 20.8746 17.9174 21.2582Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M18.6982 20.9803C18.4733 21.3639 18.5527 21.8137 18.5527 21.8137C18.5527 21.8137 18.9892 21.655 19.2141 21.2846C19.439 20.9009 19.3596 20.4512 19.3596 20.4512C19.3596 20.4512 18.9231 20.6099 18.6982 20.9803Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M17.6793 20.0017C17.9703 20.3324 18.4333 20.3986 18.4333 20.3986C18.4333 20.3986 18.4201 19.9356 18.129 19.6049C17.838 19.2742 17.375 19.208 17.375 19.208C17.375 19.208 17.3882 19.671 17.6793 20.0017Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M18.3814 19.5516C18.2491 19.9749 18.4476 20.3982 18.4476 20.3982C18.4476 20.3982 18.8444 20.1469 18.9635 19.7236C19.0958 19.3003 18.8973 18.877 18.8973 18.877C18.8973 18.877 18.5005 19.1415 18.3814 19.5516Z",
    fill: "#FFB448"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M17.2419 18.9827C17.599 19.234 18.0753 19.1944 18.0753 19.1944C18.0753 19.1944 17.9562 18.7446 17.599 18.4932C17.2419 18.2419 16.7656 18.2816 16.7656 18.2816C16.7656 18.2816 16.8715 18.7314 17.2419 18.9827Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M17.8104 18.401C17.7839 18.8376 18.0617 19.208 18.0617 19.208C18.0617 19.208 18.3792 18.8773 18.4057 18.4407C18.4321 18.0042 18.1543 17.6338 18.1543 17.6338C18.1543 17.6338 17.8368 17.9645 17.8104 18.401Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M16.6328 18.0566C17.0297 18.255 17.4927 18.136 17.4927 18.136C17.4927 18.136 17.3075 17.7126 16.9106 17.5142C16.5138 17.3158 16.0508 17.4348 16.0508 17.4348C16.0508 17.4348 16.236 17.8714 16.6328 18.0566Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M17.1095 17.3817C17.1492 17.8182 17.4932 18.1357 17.4932 18.1357C17.4932 18.1357 17.7577 17.7521 17.718 17.3156C17.6784 16.879 17.3344 16.5615 17.3344 16.5615C17.3344 16.5615 17.0698 16.9452 17.1095 17.3817Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M16.317 16.7344C16.3037 16.7476 16.2773 16.7741 16.2508 16.7873C16.2376 16.7873 16.2376 16.8005 16.2244 16.8005C17.6134 17.9911 18.4864 19.6976 18.4864 21.6025C18.4864 25.1742 15.4174 28.0713 11.634 28.0713C7.85065 28.0713 4.78161 25.1742 4.78161 21.6025C4.78161 19.777 5.58855 18.1366 6.87173 16.9593C6.83204 16.946 6.79236 16.9328 6.7659 16.9196C5.48273 18.1102 4.67578 19.777 4.67578 21.6025C4.67578 25.2271 7.79773 28.1771 11.634 28.1771C15.4703 28.1771 18.5923 25.2271 18.5923 21.6025C18.6055 19.6711 17.7192 17.9382 16.317 16.7344Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M7.57319 17.1973C7.13665 17.2899 6.72656 17.0782 6.72656 17.0782C6.72656 17.0782 7.01759 16.7078 7.45414 16.6152C7.89068 16.5226 8.30077 16.7343 8.30077 16.7343C8.30077 16.7343 7.99651 17.1047 7.57319 17.1973Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M7.26696 16.4296C7.12145 16.8397 6.71136 17.0778 6.71136 17.0778C6.71136 17.0778 6.55262 16.6413 6.69813 16.2312C6.84365 15.8211 7.25373 15.583 7.25373 15.583C7.25373 15.583 7.42571 16.0196 7.26696 16.4296Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M15.7588 17.1973C16.1954 17.2899 16.6055 17.0782 16.6055 17.0782C16.6055 17.0782 16.3144 16.7078 15.8779 16.6152C15.4413 16.5226 15.0312 16.7343 15.0312 16.7343C15.0312 16.7343 15.3223 17.1047 15.7588 17.1973Z",
    fill: "#FFB448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M16.0497 16.4296C16.1952 16.8397 16.6053 17.0778 16.6053 17.0778C16.6053 17.0778 16.764 16.6413 16.6185 16.2312C16.473 15.8211 16.0629 15.583 16.0629 15.583C16.0629 15.583 15.9042 16.0196 16.0497 16.4296Z",
    fill: "#FFB448"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M12.7963 21.1203C13.6693 21.3584 14.1985 21.9008 14.1985 22.8136C14.1985 24.983 11.1559 25.3005 9.10547 24.7317L9.2113 23.2104C10.005 23.6205 11.3014 23.7792 11.9628 23.3427C12.5052 22.9855 12.4523 22.3109 12.0554 22.0331C11.6189 21.7288 10.9442 21.8479 10.3093 21.8214V20.5382H11.1162C12.6904 20.5382 12.7301 18.8847 11.0765 18.8847C10.5209 18.8847 9.9521 19.0037 9.42296 19.2021L9.34358 17.8396C9.68753 17.7338 10.0447 17.6544 10.4019 17.6015C14.3175 17.0194 14.4631 19.6255 13.7487 20.4985C13.5371 20.8028 13.2196 21.0012 12.7963 21.1203Z",
    fill: "#B64C04"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7478,
    height: 32,
    fill: "white",
    transform: "translate(0.574219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeBadgeIcon);
export default __webpack_public_path__ + "static/media/bronzeBadgeIcon.bcd18c46ed40d5d9d3b39e3359de3cf8.svg";
export { ForwardRef as ReactComponent };